import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { clearFormTemplate, getFormTemplate, getFormTemplates, getMyForms } from 'actions/templates';
import PreviewFormTemplate from 'containers/FormTemplate/Display/PreviewFormTemplate';
import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Checkbox, Button } from '@haldor/ui';
import { Spinner } from 'UI';
import { PRESCHOOL } from "constants/schoolTypes";

var ConnectForm = /*#__PURE__*/function (_Component) {
  _inherits(ConnectForm, _Component);

  var _super = _createSuper(ConnectForm);

  /* Class setup */
  function ConnectForm(props) {
    var _this;

    _classCallCheck(this, ConnectForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.initialValues != null) {
        var initialValues = _this.props.initialValues;

        _this.setState({
          loading: true
        });

        _this.props.getFormTemplate(initialValues.formTemplateID).then(function () {
          _this.setState({
            loading: false
          });
        });
      } else {
        if (_this.props.templates == null) {
          _this.props.getFormTemplates();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearFormTemplate();
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        var submits = [];
        values.formTemplateId = _this.state.template;

        if (_this.state.targetStudents) {
          var obj = JSON.parse(JSON.stringify(values));
          obj.targetedAudience = 'STUDENT';
          submits.push(obj);
        }

        if (_this.state.targetGuardians) {
          var obj = JSON.parse(JSON.stringify(values));
          obj.targetedAudience = 'GUARDIAN';
          submits.push(obj);
        }

        if (_this.state.targetFollowUp) {
          var obj = JSON.parse(JSON.stringify(values));
          obj.targetedAudience = 'FOLLOWUP';
          submits.push(obj);
        }

        if (_this.props.onSubmit != null) {
          _this.props.onSubmit(submits).then(function () {
            resolve(1);
          });
        } else {
          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onClose != null) {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFormChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  template: event.target.value
                });

                if (!(event.target.value != '0')) {
                  _context.next = 9;
                  break;
                }

                _this.setState({
                  loading: true
                });

                _context.next = 5;
                return _this.props.getFormTemplate(event.target.value);

              case 5:
                _this.setState({
                  loading: false
                });

                _this.props.change('title', _this.props.formTemplate.title);

                _context.next = 11;
                break;

              case 9:
                _this.props.clearFormTemplate();

                _this.props.change('title', '');

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value != 'undefined' && value != '' && value != null) {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    var template = '0';
    var targetedAudience = 'FOLLOWUP';

    if (props.initialValues != null) {
      if (props.initialValues.formTemplateID) {
        template = props.initialValues.formTemplateID;
      }
    }

    _this.state = {
      loading: false,
      allChecked: false,
      template: template,
      targetedAudience: targetedAudience,
      targetFollowUp: props.followUp != null ? true : false,
      targetParticipants: false,
      targetGuardians: false,
      targetStudents: false
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(ConnectForm, [{
    key: "render",
    value:
    /* Render methods */
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          translate = _this$props.translate,
          valid = _this$props.valid;

      if (submitting) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var isPreschool = this.props.currentUser.schools.getActiveSchool(this.props.currentUser.userId).type == PRESCHOOL;
      var audienceValid = true;

      if (!this.state.targetStudents && !this.state.targetGuardians && !this.state.targetFollowUp) {
        audienceValid = false;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, this.props.initialValues == null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('form-template'), "*"), /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        value: this.state.template,
        onChange: this.onFormChange
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, this.props.translate('select-form-template')), this.props.templates != null ? this.props.templates.map(function (template) {
        return /*#__PURE__*/React.createElement("option", {
          value: template.id,
          key: template.id
        }, template.title);
      }) : null))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('form-title'), "*"), /*#__PURE__*/React.createElement(Field, {
        component: "input",
        type: "text",
        validate: this.required,
        name: "title"
      })), this.props.followUp == null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row textarea"
      }, /*#__PURE__*/React.createElement("label", null, translate('description')), /*#__PURE__*/React.createElement(Field, {
        component: "textarea",
        name: "text"
      })) : null, this.props.initialValues == null && this.props.followUp == null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.participants ? this.props.translate('who-should-answer') : this.props.translate('use'), "*"), !this.props.participants && !this.props.isfollowUpAdded ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '0.75rem'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          _this2.setState({
            targetFollowUp: !_this2.state.targetFollowUp
          });
        },
        value: this.state.targetFollowUp,
        label: translate('follow-up-to-the-meeting')
      })) : null, !this.props.participants && !this.props.followUp ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '0.75rem'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          if (!_this2.state.targetParticipants) {
            _this2.setState({
              targetParticipants: !_this2.state.targetParticipants
            });
          } else {
            _this2.setState({
              targetParticipants: !_this2.state.targetParticipants,
              targetStudents: false,
              targetGuardians: false
            });
          }
        },
        value: this.state.targetParticipants,
        label: translate('send-to-participants')
      })) : null, this.state.targetParticipants || this.props.participants ? /*#__PURE__*/React.createElement("div", {
        className: "select",
        style: {
          marginLeft: '2rem'
        }
      }, !isPreschool ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '0.35rem'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          _this2.setState({
            targetStudents: !_this2.state.targetStudents
          });
        },
        value: this.state.targetStudents,
        label: translate('Students')
      })) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          _this2.setState({
            targetGuardians: !_this2.state.targetGuardians
          });
        },
        value: this.state.targetGuardians,
        label: translate('Guardians')
      }))) : null) : null, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, this.state.template != '0' && this.props.formTemplate != null ? /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }) : null, this.state.template != '0' && this.props.formTemplate != null && !this.state.loading ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 40
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          marginBottom: '.5rem',
          fontWeight: 600
        }
      }, translate('preview'))), /*#__PURE__*/React.createElement(PreviewFormTemplate, {
        fields: this.props.formTemplate.fields
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: !valid || !audienceValid || this.state.template == '0'
      }, this.props.next ? translate('next') : translate('save')), this.props.next ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.goToPage
      }, "Hoppa \xF6ver") : null, this.props.onClose != null ? /*#__PURE__*/React.createElement("div", {
        className: "pull-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onCancel
      }, this.props.translate('Cancel'))) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    }
  }]);

  return ConnectForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    templates: state.Templates.templates,
    currentUser: state.user.currentUser,
    formTemplate: state.Templates.formTemplate
  };
}

export default connect(mapStateToProps, {
  getMyForms: getMyForms,
  getFormTemplate: getFormTemplate,
  clearFormTemplate: clearFormTemplate,
  getFormTemplates: getFormTemplates
})(reduxForm({
  form: 'ConnectFormToMeeting',
  destroyOnUnmount: true
})(ConnectForm));